import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const WorkspaceImportCallback = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const message = params.get("message");
    if (message) {
      toast.error(message);
    } else {
      const imported = params.get("imported") ?? "0";
      const updated = params.get("updated") ?? "0";
      const errors = Number(params.get("errors") ?? "0");
      const parts = [`${imported} novo(s)`, `${updated} atualizado(s)`];
      if (errors > 0) parts.push(`${errors} erro(s)`);
      toast.success(`Workspace importado: ${parts.join(", ")}`);
    }
    navigate("/rh/colaboradores", { replace: true });
  }, []);

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-3 bg-background">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">Processando importação...</p>
    </div>
  );
};

export default WorkspaceImportCallback;
